import classNames from 'classnames';
import { Figure, Video } from 'yoso';
import { ContentModel } from '~/components/Content/Content.hooks';
import './Content.scss';

export type NftProps = ContentModel & {
  origin?: boolean;
  draggable?: boolean;
  className?: string;
};
export const Content = ({ className, origin, draggable, ...content }: NftProps) => {
  const { originContentsUrl, contentsUrl } = content;

  switch (content.contentsType) {
    case 'IMAGE':
      return (
        <Figure
          className={classNames('content', className)}
          src={origin ? originContentsUrl : contentsUrl}
          srcSet={null}
          draggable={draggable}
        />
      );
    case 'VIDEO':
      return (
        <Video
          className={classNames('content', className)}
          poster={contentsUrl}
          src={originContentsUrl}
          autoplay
          loop
          volume={false}
          seekbar={false}
          currentTime={false}
          duration={false}
          playPause={false}
          fullscreen={false}
          errors={false}
        />
      );
    default:
      return <Figure className={classNames('content', className)} draggable={draggable} />;
  }
};
